// What a column's short label means, in a sentence, for `Term` (kit/Why.tsx).
//
// THE CLIENT'S OWN WORDS. These name this screen's columns — the labels are
// the client's layout choice, so what they mean is too; a stat's own name
// comes from the sport's catalog, never from here (`useUsageLabels`, the
// breakdown's labels). Facts about the number, never what to do with it
// (docs/decisions/2026-09-12-tools-not-instructions.md): no "start", no
// "good", no "best".
//
// One place, so a column says the same thing on every screen it appears on
// (UX_STANDARDS UX-20) and a change of wording is one edit.

export const GLOSSARY = {
  slot: 'Where he plays: a starting spot, the bench (BN) or injured reserve (IR). On your own team, tap or click a badge to move him.',
  weekProjection:
    "Projected points this week, in this league's scoring. Tap or hover over a projection to see what it rests on.",
  weekPoints:
    "Points this week, in this league's scoring. Tap or hover over a score to see it stat by stat.",
  seasonAverage: "Points a game this season, in this league's scoring.",
  opponent:
    'His opponent this week. The chip beside it ranks how many points that team has allowed to his position this season: 1st most is the most allowed.',
  status:
    'Injury news and the lock. A locked player stays where he is until the week is over; the league’s rules say when players lock.',
  proTeam: 'His pro team.',
  position: 'The position he plays.',
  seasonPoints: "Points this season, in this league's scoring.",
  lastThree: 'Points a game over his last three games.',
  form: 'His last three weeks against his season: points a game above (+) or below (−) his average.',
  range: 'His lowest and highest week this season.',
  owned:
    "The share of this site's leagues that have him on a roster, and which way it moved over the last seven days.",
  winLoss: 'Wins and losses. Ties, when there are any, come third.',
  pointsFor: 'Points for: everything the team has scored this season.',
  pointsAgainst: "Points against: everything the team's opponents have scored against it.",
  gamesBack:
    'Games back: how many games behind the best record in the league. A tie counts as half a game.',
  pointsBack: 'Points back: how far behind the most points in the league.',
  maxPoints:
    'Max PF: what the team would have scored starting its best possible lineup every week, from the players it had that week.',
  allPlayRecord:
    'All-play record: every week, a win for each team you outscored and a loss for each team that outscored you.',
  streak: 'The current run of results: W3 is three wins in a row, L1 a loss last time out.',
  lastFive: 'The last five games, oldest on the left: W a win, L a loss, T a tie.',
  topPlayers:
    "A position's top players are the league's best there by points a game this season, of those on a roster: as many as the league starts there, eight teams starting two running backs making sixteen. A flex is no position's own and is not counted.",
  tradePartners:
    'The teams with more of the top players than they start at a position where you have fewer than you start. Those that also have fewer where you have more come first. Counts, not advice: the rosters by position show the rest.',
  fromLine:
    'Games from the playoff line: a team in the playoffs is that many games clear of the first team out (+1), a team outside that many short of the last team in (1 back). A dash is level with the team across the line, which the tiebreakers put there.',
  bench: "What the bench scored. It does not count toward the matchup's score.",
  winChance:
    "From the points already scored, both teams' projections for the players still to play, and how far apart those can land. A projection; nobody knows the future.",
} as const;

/** A streak in words: "W3" is three wins in a row, "L1" the last game lost. */
export function streakWords(streak: string): string {
  const kind = streak[0];
  const n = Number(streak.slice(1));
  if (!Number.isFinite(n) || n < 1) return 'The current run of results.';
  const word = kind === 'W' ? 'win' : kind === 'L' ? 'loss' : kind === 'T' ? 'tie' : 'game';
  if (n === 1) return `The streak: a ${word} last time out.`;
  return `The streak: ${n} ${word === 'loss' ? 'losses' : `${word}s`} in a row.`;
}
